// extracted by mini-css-extract-plugin
export var closeButton = "_j5-1";
export var closeX = "_j5-3";
export var container = "_j5-0";
export var image = "_j5-2";